/**
 * IMPORTANT
 * Shop (body type + region) SEO content is synced into `src/client-content/` via:
 * - `pnpm sync:client-content`
 */

import type {
  BodyTypeData as ClientBodyTypeData,
} from '@/client-content/(browse)/shop/_lib/body-type-data'
import {
  BODY_TYPES as CLIENT_BODY_TYPES,
  BODY_TYPE_MAP as CLIENT_BODY_TYPE_MAP,
} from '@/client-content/(browse)/shop/_lib/body-type-data'

import type {
  StateData as ClientStateData,
  CityData as ClientCityData,
} from '@/client-content/(browse)/shop/_lib/regional-data'
import {
  states as CLIENT_STATES,
  getStateBySlug as getClientStateBySlug,
  getCityBySlug as getClientCityBySlug,
  getAllCities as getClientAllCities,
  getStatesWithCities as getClientStatesWithCities,
  formatFeeCents,
} from '@/client-content/(browse)/shop/_lib/regional-data'

export type BodyTypeData = ClientBodyTypeData
export type StateData = ClientStateData & {
  seo: { title: string; description: string }
}
export type CityData = ClientCityData

function withStateSeo(state: ClientStateData): StateData {
  return {
    ...state,
    seo: {
      title: `Used Cars in ${state.name} | Bespokian Auto`,
      description: `Shop used cars available for delivery in ${state.name}. Explore inventory, delivery estimates, fees, and popular makes across ${state.name}.`,
    },
  }
}

export function getBodyTypes(): BodyTypeData[] {
  return CLIENT_BODY_TYPES
}

export function getBodyTypeBySlug(slug: string): BodyTypeData | undefined {
  return CLIENT_BODY_TYPE_MAP.get(slug)
}

export function getStates(): StateData[] {
  return CLIENT_STATES.map(withStateSeo)
}

export function getStatesWithCities(): StateData[] {
  return getClientStatesWithCities().map(withStateSeo)
}

export function getAllCities(): CityData[] {
  return getClientAllCities()
}

export function getStateBySlug(slug: string): StateData | undefined {
  const state = getClientStateBySlug(slug)
  return state ? withStateSeo(state) : undefined
}

export function getCityBySlug(stateSlug: string, citySlug: string): CityData | undefined {
  return getClientCityBySlug(stateSlug, citySlug)
}

export function getShopPageCounts(): {
  shopHub: number
  bodyTypes: number
  states: number
  cities: number
  total: number
} {
  const shopHub = 1
  const bodyTypes = CLIENT_BODY_TYPES.length
  const states = CLIENT_STATES.length
  const cities = getClientAllCities().length
  return { shopHub, bodyTypes, states, cities, total: shopHub + bodyTypes + states + cities }
}

export { formatFeeCents }

